import React, { ReactNode } from 'react';

interface Props {
  header: ReactNode;
  body: ReactNode;
  footer: ReactNode;
  overlay?: ReactNode;
  className?: string;
}

const ChatPanel: React.FC<Props> = ({ header, body, footer, overlay, className }) => (
  // data-sheet-swipe: on narrow phones the panel is a bottom sheet — swipe its
  // header down to close it (shared mobile-sheet-gestures)
  <div
    className={`bot-panel${className ? ` ${className}` : ''}`}
    data-sheet-swipe="handle"
  >
    {header}
    <div className="bot-panel__body">{body}</div>
    {footer}
    {overlay}
  </div>
);

export default ChatPanel;
